import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import './FollowUpFilterButton.scss'; // Your SCSS file

// Filter button component
interface FilterButtonProps {
    onFilterClick: () => void;
}

export const FollowUpFilterButton: React.FC<FilterButtonProps> = ({ onFilterClick }) => {
    return (
        <div className="filter-button-container">
            <Button variant="secondary" className="filter-button-follow-up button-cancel" onClick={onFilterClick}>
                <FontAwesomeIcon icon={faFilter} />
            </Button>
        </div>
    );
};

export default FollowUpFilterButton;
